import { combineReducers } from 'redux';
import { marginAccountStateReducer } from './marginAccountStateReducer';
import { marginHistoryReducer } from './marginHistoryReducer';
import { marginInstrumentReducer } from './marginInstrumentReducer';
import { marginProductReducer } from './marginProductReducer';
import { marginTransfersReducer } from './marginTransferReducer';
export var marginReducer = combineReducers({
  accountState: marginAccountStateReducer,
  history: marginHistoryReducer,
  instrument: marginInstrumentReducer,
  product: marginProductReducer,
  transfer: marginTransfersReducer
});